export default "__VITE_ASSET__CZKLxPka__"